import { render, staticRenderFns } from "./NewsComments.vue?vue&type=template&id=51568ab5&scoped=true&"
import script from "./NewsComments.vue?vue&type=script&lang=js&"
export * from "./NewsComments.vue?vue&type=script&lang=js&"
import style0 from "./NewsComments.vue?vue&type=style&index=0&id=51568ab5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51568ab5",
  null
  
)

export default component.exports